import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from './index';
import Tooltip from '../molecules/Tooltip';
import Icon, { IconSizes } from '../foundations/Icon';

const TableCellCheckbox = ({
    tdClassName = '',
    className = '',
    iconTooltipClassName = '',
    itemsClassName = '',
    iconClassName = '',
    value = false,
    onChange = () => {},
    disabled = false,
    tooltipText = null,
    tooltipData = null,
    id,
    rowIndex = null,
    iconName = null,
    iconTooltip = null,
}) => {
    const handleChange = e => {
        if (rowIndex !== null && rowIndex !== undefined) {
            // New signature: onChange(e, id, rowIndex)
            onChange(e, id, rowIndex);
        } else {
            // Old signature: onChange(e, id) - maintain original behavior
            onChange(e, id);
        }
    };

    return (
        <td className={tdClassName}>
            <div className={itemsClassName}>
                {iconName && (
                    <Tooltip
                        titleTranslationKey={iconTooltip}
                        disabled={!iconTooltip}
                        contentClass={iconTooltipClassName}
                        wrapperClass={iconClassName}
                    >
                        <Icon name={iconName} size={IconSizes.X_SMALL} color="var(--warning1Color)" />
                    </Tooltip>
                )}
                <Tooltip titleTranslationKey={tooltipText} titleTranslationData={tooltipData} disabled={!tooltipText}>
                    <Checkbox className={className} checked={value} disabled={disabled} onChange={handleChange} />
                </Tooltip>
            </div>
        </td>
    );
};

TableCellCheckbox.propTypes = {
    tdClassName: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltipText: PropTypes.string,
    tooltipData: PropTypes.objectOf(PropTypes.any),
    rowIndex: PropTypes.any,
    id: PropTypes.any,
    iconName: PropTypes.string,
    iconTooltip: PropTypes.string,
    iconTooltipClassName: PropTypes.string,
    itemsClassName: PropTypes.string,
    iconClassName: PropTypes.string,
};

export default TableCellCheckbox;
